import React, { useEffect, useRef, useState } from "react";
import "./index.scss";
import Session from "../../../components/chat/session";
import { useNavigate, useParams } from "react-router-dom";
import * as _ from "lodash";
import * as Moment from "moment";
import Dropdown from "../../../components/core/dropdown";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import {
  countSessionWaiting,
  editSession,
  querySession,
} from "../../../store/session/thunkAction";
import { listStaff } from "../../../store/staff/thunkAction";
import { SessionAction } from "../../../store/session/slice";
import { listProfileShorthandByProfileId } from "../../../store/profile-shorthand/thunkAction";
import { SessionStatus } from "../../../constant/enums";
import {
  listRequesterOffline,
  listRequesterOnline,
} from "../../../store/requester/thunkAction";
import { socketActions } from "../../../store/socket/slice";

const ChatContact = () => {
  const params = useParams();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const [agents, setAgents] = useState([]);
  const [isSearch, setIsSearch] = useState(false);
  const [staffId, setStaffId] = useState(null);
  const [domain, setDomain] = useState("");
  const [time, setTime] = useState(null);
  const [startAt, setStartAt] = useState(null);
  const [endAt, setEndAt] = useState(null);
  const [search, setSearch] = useState("");
  const timeoutRef = useRef(null);

  const sessionManage = useSelector((state) => state.sessionManage);
  const tokenManage = useSelector((state) => state.tokenManage);
  const socketManage = useSelector((state) => state.socketManage);
  const staffManage = useSelector((state) => state.staffManage);
  const profileManage = useSelector((state) => state.profileManage);
  const requesterManage = useSelector((state) => state.requesterManage);
  const requesterStatusChange = _.get(
    socketManage,
    "requesterStatusChange",
    {}
  );

  const staffChangeGroup = _.get(socketManage, "staffChangeGroup", {});
  const requesterOnline = _.get(requesterManage, "requesterOnline");
  const requesterOffline = _.get(requesterManage, "requesterOffline");
  const totalSessionWaiting = _.get(sessionManage, "totalSessionWaiting");
  const profile = _.get(profileManage, "profile");
  const listProfileAllowed = _.get(profileManage, "listProfileAllowed");
  const staffs = _.get(staffManage, "staffs", {});
  const staff = _.get(staffManage, "staff", {});
  const hasToken = _.get(tokenManage, "hasToken");
  const sessionChange = _.get(socketManage, "sessionChange");
  const sessions = _.get(sessionManage, "sessions");
  const skip = _.get(sessionManage, "skip");
  const limit = _.get(sessionManage, "limit");
  const total = _.get(sessionManage, "total");

  const chatId = _.get(params, "id");
  const sessionId = _.get(params, "sessionId");

  useEffect(() => {
    if (profile._id) {
      dispatch(
        listProfileShorthandByProfileId({ profileId: profile._id, search: "" })
      );
    }
  }, [dispatch, profile._id]);

  useEffect(() => {
    if (hasToken) {
      dispatch(listStaff());
    }
  }, [dispatch, hasToken]);

  useEffect(() => {
    if (hasToken) {
      dispatch(countSessionWaiting());
      dispatch(listRequesterOnline());
      dispatch(listRequesterOffline());
    }
  }, [dispatch, hasToken, requesterStatusChange, staffChangeGroup]);

  useEffect(() => {
    setSearch("");
    dispatch(SessionAction.clearSessions());
  }, [isSearch, dispatch]);

  useEffect(() => {
    if (sessionChange) {
      const status = _.get(sessionChange, "status", null);

      if (status && status !== SessionStatus.PENDING) {
        dispatch(SessionAction.clearSessionById(sessionId));
      }

      dispatch(socketActions.clearSessionChange());
    }
  }, [dispatch, t, sessionChange, sessionId, staff._id]);

  useEffect(() => {
    dispatch(SessionAction.clearSessions());
  }, [dispatch, isSearch, search]);

  useEffect(() => {
    let filter = {
      skip,
      limit,
      status: SessionStatus.PENDING,
      isChat: true,
    };

    if (isSearch) {
      filter = _.assign({}, filter, {
        search,
        domain,
        staffId,
        status: null,
        startAt,
        endAt,
        isUnique: true,
      });
    }

    if (hasToken) {
      if (!search) {
        dispatch(querySession(filter));

        return;
      }

      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }

      timeoutRef.current = setTimeout(() => {
        dispatch(querySession(filter));
      }, 1000);

      return () => {
        if (timeoutRef.current) {
          clearTimeout(timeoutRef.current);
        }
      };
    }
  }, [
    dispatch,
    search,
    skip,
    limit,
    hasToken,
    sessionChange,
    domain,
    staffId,
    isSearch,
    startAt,
    endAt,
  ]);

  useEffect(() => {
    setAgents(_.values(staffs));
  }, [staffs]);

  useEffect(() => {
    const handleKeyDown = async (event) => {
      if (event.ctrlKey && event.altKey && event.code === "Space") {
        const requester = requesterOffline[0];
        if (!requester) {
          return;
        }

        const session = _.get(requester, "session");
        if (!session) {
          return;
        }

        const sessionId = _.get(session, "_id");
        const staffId = _.get(staff, "_id");
        try {
          await dispatch(
            editSession({
              id: sessionId,
              data: {
                staffId,
                status: SessionStatus.PENDING,
                updateTime: +Moment.utc(),
              },
            })
          ).unwrap();
          navigate(`/chat/${chatId}/message/session-id/${sessionId}`);
        } catch (error) {}
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [chatId, dispatch, navigate, requesterOnline, staff, requesterOffline]);

  const chatNow = async () => {
    const requester = requesterOffline[0];

    if (!requester) {
      return;
    }

    const session = _.get(requester, "session");

    if (!session) {
      return;
    }

    const sessionId = _.get(session, "_id");
    const staffId = _.get(staff, "_id");
    try {
      await dispatch(
        editSession({
          id: sessionId,
          data: {
            staffId,
            status: SessionStatus.PENDING,
            updateTime: +Moment.utc(),
          },
        })
      ).unwrap();
      navigate(`/chat/${chatId}/message/session-id/${sessionId}`);
    } catch (error) {}
  };

  const handleSelectDate = (option) => {
    const id = _.get(option, "id", null);
    dispatch(SessionAction.clearSessions());
    setTime(id);

    if (id === "day") {
      setStartAt(Moment().startOf("day").valueOf());
      setEndAt(Moment().endOf("day").valueOf());
      return;
    }

    if (id === "week") {
      setStartAt(Moment().startOf("isoWeek").valueOf());
      setEndAt(Moment().endOf("isoWeek").valueOf());
      return;
    }

    if (id === "month") {
      setStartAt(Moment().startOf("month").valueOf());
      setEndAt(Moment().endOf("month").valueOf());

      return;
    }

    setStartAt(null);
    setEndAt(null);
  };

  const mapConfigAgent = {
    id: "_id",
    name: "name",
  };
  const mapConfigDomain = {
    id: "domain",
    name: "domain",
  };

  return (
    <div className="col-md-3 border-end h-100">
      <div className="chat-left-box d-flex flex-column h-100">
        <div className="px-3 h-60 d-flex align-items-center">
          <div className="d-flex gap-3 w-100 align-items-center">
            <div
              className="input-icon w-100 "
              onClick={() => {
                setIsSearch(true);
              }}
            >
              <img src="/img/chat/icon/search.svg" alt="" />
              <input
                className="chat-search-btn border-0 rounded-5 form-control bg-gray-light"
                placeholder={t("agent.contact.search")}
                value={search}
                onChange={(e) => setSearch(e.target.value)}
              />
            </div>
            {isSearch && (
              <button
                className="button-close"
                onClick={() => {
                  setIsSearch(false);
                }}
              >
                {t("common.closed")}
              </button>
            )}
          </div>
        </div>
        {isSearch && (
          <div>
            <div
              className="px-3 d-flex align-items-start gap-2"
              style={{ paddingBottom: "10px" }}
            >
              <Dropdown
                config={{
                  options: [
                    { name: t("agent.contact.to_day"), id: "day" },
                    { name: t("agent.contact.this_week"), id: "week" },
                    { name: t("agent.contact.this_month"), id: "month" },
                  ],
                  onSelect: handleSelectDate,
                  placeholder: t("agent.contact.date"),
                  className: "contact-dropdown-custom",
                  value: time,
                }}
              />
              <Dropdown
                config={{
                  options: listProfileAllowed,
                  map: mapConfigDomain,
                  onSelect: (option) => {
                    dispatch(SessionAction.clearSessions());
                    setDomain(_.get(option, "domain", ""));
                  },
                  placeholder: t("agent.contact.domain"),
                  className: "contact-dropdown-custom",
                  value: domain,
                }}
              />
              <Dropdown
                config={{
                  options: agents,
                  map: mapConfigAgent,
                  onSelect: (option) => {
                    dispatch(SessionAction.clearSessions());
                    setStaffId(_.get(option, "_id", null));
                  },
                  placeholder: t("agent.contact.agent"),
                  className: "contact-dropdown-custom",
                  value: staffId,
                }}
              />
            </div>
          </div>
        )}
        <div className="chat-contact-box">
          <ul className="chat-contact list-group rounded-0">
            {sessions.map((session) => {
              const isSession = sessionId === session._id;
              return (
                <li
                  key={session._id}
                  className={
                    isSession
                      ? "list-group-item list-group-item-action actived rounded-0 border-0 text-wrap"
                      : "list-group-item list-group-item-action rounded-0 border-0 text-wrap"
                  }
                >
                  <Session
                    config={{
                      session: session,
                      isSearch: isSearch,
                    }}
                  />
                </li>
              );
            })}
            {sessions.length < total && (
              <li
                className="list-group-item list-group-item-action rounded-0 border-0 text-wrap"
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <button
                  className="btn btn-primary"
                  onClick={() => {
                    dispatch(SessionAction.setSkip(sessions.length));
                  }}
                >
                  {t("agent.contact.show_more")}
                </button>
              </li>
            )}
          </ul>
        </div>
        <div className="px-3 d-flex h-60 align-items-center border-top">
          <div className="d-flex gap-2 w-100 align-items-center">
            <img
              onClick={() => chatNow()}
              width="40px"
              height="40px"
              src="/img/chat/icon/down.svg"
              alt=""
            />
            <div className="small">
              <div onClick={() => chatNow()}>
                {totalSessionWaiting} {t("agent.contact.new_requester")}
              </div>
              <div className="color-gray">
                {t("agent.contact.shortcut")}:{" "}
                <img
                  height={"30px"}
                  src="/img/chat/icon/shortcode.svg"
                  alt=""
                />
              </div>
            </div>
            <button
              className="btn btn-visitor border-0 btn-gray ms-auto bg-gray-light position-relative"
              onClick={() => {
                dispatch(countSessionWaiting());
                dispatch(listRequesterOnline());
                dispatch(listRequesterOffline());
                navigate(`/chat/${chatId}/visitor`);
              }}
              style={{ cursor: "pointer" }}
              title={t("agent.visitor.button_desc")}
            >
              <img src="/img/chat/icon/mem.svg" alt="" />
              {requesterOnline.length ? (
                <span className="dot-online text-danger">●</span>
              ) : (
                <span></span>
              )}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChatContact;
